namespace $ {

	/** Retry native rights ordering without enabling persistent cache repair. */
	export function $shm_hitalama_baza_diff_rank_retry< Result >(
		native: $giper_baza_land['diff_apply'],
		host: $giper_baza_land,
		units: readonly $giper_baza_unit[],
		skip_load?: 'skip_load',
	): Result {
		const retried = new Set< string >
		while( true ) {
			try {
				return native.call( host, units, skip_load ) as Result
			} catch( error ) {
				if( error instanceof Promise ) throw error
				if( !( error instanceof Error ) ) throw error
				if( error.message !== 'No Seal for Sand' && error.message !== 'No Seal for Gift' ) throw error
				if(
					!( error.cause instanceof $giper_baza_unit_sand )
					&& !( error.cause instanceof $giper_baza_unit_gift )
				) throw error
				const sealed = error.cause
				const hash = sealed.hash().str
				// Retry only with this packet's own verifiable proof. Native signature
				// and current rank checks run again; no trusted flag is introduced.
				const covered = units.some( unit =>
					unit instanceof $giper_baza_unit_seal
					&& unit.lord().str === sealed.lord().str
					&& unit.hash_list().some( item => item.str === hash )
				)
				if( !covered ) throw error
				const key = sealed.path()
				if( retried.has( key ) ) throw error
				retried.add( key )
			}
		}
	}
}
